<div class="flex align-items-center justify-content-center min-h-screen p-4" style="background:var(--dh-ground)">
    <div class="dh-card flex flex-column align-items-center text-center gap-3" style="max-width:460px;width:100%;padding:40px 28px">
        <span class="dh-disp" style="font-size:1.4rem;color:var(--dh-ink)">DRINK HOPPING</span>
        <span class="dh-disp" style="font-size:4rem;line-height:1;color:var(--dh-accent)">404</span>
        <h1 class="dh-h2" style="font-size:1.4rem">Esta página no existe</h1>
        <p class="dh-muted m-0">Puede que el link esté mal o que el registro se haya eliminado.</p>
        <div class="flex gap-2 mt-2"><a pButton routerLink="/" label="Ir al inicio" icon="pi pi-home"></a></div>
    </div>
</div>
